import script from "./KanaStudy.vue?vue&type=script&setup=true&lang=js"
export * from "./KanaStudy.vue?vue&type=script&setup=true&lang=js"

import "./KanaStudy.vue?vue&type=style&index=0&id=683be4b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-683be4b1"]])

export default __exports__